"use client"
import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import ReactMarkdown from "react-markdown"

interface PricingPartnerTooltip {
    locale: string
    explaination?: any
}

const TooltipExplaination: React.FunctionComponent<PricingPartnerTooltip> = ({ locale, explaination }) => {
    return (
        <>
            <OverlayTrigger placement="right" overlay={(
                <Tooltip id="info" className="explaination">
                    <ReactMarkdown>{explaination.content}</ReactMarkdown>
                </Tooltip>
            )}>
                <span className="title cursor-pointer">{explaination?.title}</span>
            </OverlayTrigger>
        </>
    )
}

export default TooltipExplaination